export default __webpack_public_path__ + "ru.e883f542.svg";